import axios from "axios";
import { logout as logoututility } from "@utils/utils.js";
import store from "../store/store";
import CryptoJS from "crypto-js";
import {
  createEncryptedPayload,
  decryptResponse,
} from "../services/encryptionUtils"

const environment = {
  production: false,
  baseUrlUAT:
    process.env.REACT_APP_PUBLIC_URL || "https://nigeria.1dataconnect.com",
  baseUrlMediator: "http://localhost:3003",
  baseUrl: process.env.REACT_APP_PUBLIC_URL || "https://localhost:8080",
  baseMediator: process.env.REACT_APP_MEDIATOR || "mediator",
  baseCore: process.env.REACT_APP_CORE || "core",
  baseJava: process.env.REACT_APP_JAVA || "service",
  baseRuleService: process.env.REACT_APP_RULE_JAVA || "ruleService",
  baseJavaRuleService: process.env.REACT_APP_RULE_JAVA_NEW || "javaRuleService",
  baseRuleEnginePython:
    process.env.REACT_APP_RULE_ENGINE_PYTHON || "ruleEnginePython",
  dbName: process.env.REACT_APP_DBNAME || "dwh_onedataconnect_nigeria_uat",
  encryptAPI: process.env.REACT_APP_API_ENCRYPT === "true",
};

const authHeader = "Basic " + btoa(`fmoh@mailinator.com:root@PM1`);

const headers =
  process.env.NODE_ENV === "production" ? {} : { Authorization: authHeader };

// Create Axios instance with default configuration
let axiosInstance = axios.create({
  baseURL: `${environment.baseUrl}`,
  headers: headers,
  withCredentials: true, // This ensures credentials are included in requests
});

// Create Axios instance with default configuration for UAT (Used for Java and Mediator services)
let axiosInstanceUAT = axios.create({
  baseURL: `${environment.baseUrlUAT}`,
  headers: headers,
  withCredentials: true, // This ensures credentials are included in requests
});

// Create Axios instance with default configuration for Local (Used for Mediator service only)
let axiosInstanceLocal = axios.create({
  baseURL: `${environment.baseUrlMediator}`,
  headers: headers,
  withCredentials: true, // This ensures credentials are included in requests
});

// Encryption function
const encryptEmail = (email) => {
  const secretKey = "e56af8aae98a280599643993b621a0db"; // Secret key should be in an environment variable
  return CryptoJS.AES.encrypt(email, secretKey).toString();
};

// Add request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    const state = store.getState();
    const email = state.basicConfigReducer?.console?.email || null; // Access updated email from Redux store
    if (email) {
      const encryptedEmail = encryptEmail(email); // Encrypt the email
      config.headers["ue"] = encryptedEmail; // Set the email in headers
    } else {
      console.warn("Email is not set in the Redux store");
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosInstanceUAT.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const state = store.getState();
    const email = state.basicConfigReducer?.console?.email || null; // Access updated email from Redux store
    if (email) {
      const encryptedEmail = encryptEmail(email); // Encrypt the email
      config.headers["ue"] = encryptedEmail; // Set the email in headers
    } else {
      console.warn("Email is not set in the Redux store");
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosInstanceLocal.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const state = store.getState();
    const email = state.basicConfigReducer?.console?.email || null; // Access updated email from Redux store
    if (email) {
      const encryptedEmail = encryptEmail(email); // Encrypt the email
      config.headers["ue"] = encryptedEmail; // Set the email in headers
    } else {
      console.warn("Email is not set in the Redux store");
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    if (typeof response.data === "string") {
      let responseMessage = response.data;
      let responseStatus = response.status;
      response.data = {
        message: responseMessage,
        status: responseStatus,
      };
    }

    if (!response.data.status && !Array.isArray(response.data)) {
      response.data.status = response.status;
    }

    //add index to each element
    // if (response && Array.isArray(response.data) && response.data.length) {
    //   response.data = response.data.map((o, i) => ({ ...o, id: i + 1 }));
    // }

    return response;
  },
  function (error) {
    // console.log("errorerror>>", error);
    let errorres = error;
    if (errorres.response && typeof errorres.response.data === "string") {
      let responseMessage = errorres.response.data;
      let responseStatus = errorres.response.status;
      errorres.response.data = {
        message: responseMessage,
        status: responseStatus,
      };
    }

    if (errorres && errorres.response && !errorres.response.data.status) {
      errorres.response.data.status = errorres.response.status;
    }

    // Check if the status is 401 (Unauthorized)
    if (
      errorres.response &&
      errorres.response.status === 401 &&
      process.env.NODE_ENV !== "development"
    ) {
      // Redirect to the login page
      logoututility();
    }

    // Do something with response error
    // return Promise.reject(errorres?.response?.data || errorres);
    return errorres?.response || errorres;
  }
);

axiosInstanceUAT.interceptors.response.use(
  function (response) {
    if (typeof response.data === "string") {
      let responseMessage = response.data;
      let responseStatus = response.status;
      response.data = {
        message: responseMessage,
        status: responseStatus,
      };
    }

    if (!response.data.status && !Array.isArray(response.data)) {
      response.data.status = response.status;
    }

    return response;
  },
  function (error) {
    // console.log("errorerror>>", error);
    let errorres = error;
    if (errorres.response && typeof errorres.response.data === "string") {
      let responseMessage = errorres.response.data;
      let responseStatus = errorres.response.status;
      errorres.response.data = {
        message: responseMessage,
        status: responseStatus,
      };
    }

    if (errorres && errorres.response && !errorres.response.data.status) {
      errorres.response.data.status = errorres.response.status;
    }

    // Check if the status is 401 (Unauthorized)
    if (
      errorres.response &&
      errorres.response.status === 401 &&
      process.env.NODE_ENV !== "development"
    ) {
      // Redirect to the login page
      logoututility();
    }

    // Do something with response error
    return errorres?.response || errorres;
  }
);

axiosInstanceLocal.interceptors.response.use(
  function (response) {
    if (typeof response.data === "string") {
      let responseMessage = response.data;
      let responseStatus = response.status;
      response.data = {
        message: responseMessage,
        status: responseStatus,
      };
    }

    if (!response.data.status && !Array.isArray(response.data)) {
      response.data.status = response.status;
    }

    return response;
  },
  function (error) {
    // console.log("errorerror>>", error);
    let errorres = error;
    if (errorres.response && typeof errorres.response.data === "string") {
      let responseMessage = errorres.response.data;
      let responseStatus = errorres.response.status;
      errorres.response.data = {
        message: responseMessage,
        status: responseStatus,
      };
    }

    if (errorres && errorres.response && !errorres.response.data.status) {
      errorres.response.data.status = errorres.response.status;
    }

    // Check if the status is 401 (Unauthorized)
    if (
      errorres.response &&
      errorres.response.status === 401 &&
      process.env.NODE_ENV !== "development"
    ) {
      // Redirect to the login page
      logoututility();
    }

    // Do something with response error
    return errorres?.response || errorres;
  }
);

// CREATE
async function postData({
  url,
  body,
  headers,
  service = "baseCore",
  toUAT = false,
  toLocal = false,
}) {
  try {
    const instance = toUAT
      ? axiosInstanceUAT
      : toLocal
      ? axiosInstanceLocal
      : axiosInstance;

    let finalUrl = `${environment[service]}/${url}`;
    let finalBody = body;

    if (environment.encryptAPI) {
      const encryptedPayload = createEncryptedPayload(url, body, "POST");
      finalUrl = `${environment[service]}/proxy`; // backend decrypts this
      finalBody = encryptedPayload;
    }

    const response = await instance.post(finalUrl, finalBody, { headers });

    // 🔓 Decrypt response if needed
    return environment.encryptAPI ? decryptResponse(response.data) : response.data;
  } catch (error) {
    throw error;
  }
}

// READ
async function getData({
  url,
  headers,
  service = "baseCore",
  toUAT = false,
  toLocal = false,
}) {
  try {
    const instance = toUAT
      ? axiosInstanceUAT
      : toLocal
      ? axiosInstanceLocal
      : axiosInstance;

    let finalUrl = `${environment[service]}/${url}`;
    let finalBody = null;

    if (environment.encryptAPI) {
      const encryptedPayload = createEncryptedPayload(url, null, "GET");
      finalUrl = `${environment[service]}/proxy`;
      finalBody = encryptedPayload;
    }

    // Note: For GET, send as POST if encrypted, because encrypted URL can't be used in query params
    const response = environment.encryptAPI
      ? await instance.post(finalUrl, finalBody, { headers })
      : await instance.get(finalUrl, { headers });

    return environment.encryptAPI ? decryptResponse(response.data) : response.data;
  } catch (error) {
    throw error;
  }
}

// UPDATE
async function putData({
  url,
  body,
  headers,
  service = "baseCore",
  toUAT = false,
  toLocal = false,
}) {
  try {
    const instance = toUAT
      ? axiosInstanceUAT
      : toLocal
      ? axiosInstanceLocal
      : axiosInstance;

    let finalUrl = `${environment[service]}/${url}`;
    let finalBody = body;

    if (environment.encryptAPI) {
      const encryptedPayload = createEncryptedPayload(url, body, "PUT");
      finalUrl = `${environment[service]}/proxy`;
      finalBody = encryptedPayload;
    }

    const response = await instance.put(finalUrl, finalBody, { headers });
    return environment.encryptAPI ? decryptResponse(response.data) : response.data;
  } catch (error) {
    throw error;
  }
}

// DELETE
async function deleteData({
  url,
  body,
  headers,
  service = "baseCore",
  toUAT = false,
  toLocal = false,
}) {
  try {
    const instance = toUAT
      ? axiosInstanceUAT
      : toLocal
      ? axiosInstanceLocal
      : axiosInstance;

    let finalUrl = `${environment[service]}/${url}`;
    let finalBody = body;

    if (environment.encryptAPI) {
      const encryptedPayload = createEncryptedPayload(url, body, "DELETE");
      finalUrl = `${environment[service]}/proxy`;
      finalBody = encryptedPayload;
    }

    // Axios delete doesn’t take body by default, so we use request config
    const response = await instance.delete(finalUrl, {
      data: finalBody,
      headers,
    });

    return environment.encryptAPI ? decryptResponse(response.data) : response.data;
  } catch (error) {
    throw error;
  }
}

// PATCH
async function patchData({
  url,
  body,
  headers,
  service = "baseCore",
  toUAT = false,
  toLocal = false,
}) {
  try {
    const instance = toUAT
      ? axiosInstanceUAT
      : toLocal
      ? axiosInstanceLocal
      : axiosInstance;

    let finalUrl = `${environment[service]}/${url}`;
    let finalBody = body;

    if (environment.encryptAPI) {
      const encryptedPayload = createEncryptedPayload(url, body, "PATCH");
      finalUrl = `${environment[service]}/proxy`;
      finalBody = encryptedPayload;
    }

    const response = await instance.patch(finalUrl, finalBody, { headers });
    return environment.encryptAPI ? decryptResponse(response.data) : response.data;
  } catch (error) {
    throw error;
  }
}


export { getData, putData, postData, patchData, deleteData, environment };
